import * as React from 'react';
import { UserContext } from '../context/userContext';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Tooltip,
} from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArtTrackIcon from '@mui/icons-material/ArtTrack';

import { conversationService, userService } from '../api';
import { ListSkeleton } from './Skeletons';
import { NavLink } from 'react-router-dom';
import { AiFlowTextList, BundleTextList } from '../atoms';
import { ConversationItem } from '../types';

interface Props {
  conversationList?: ConversationItem[];
  menuTitle: string;
  isLoading: boolean;
}

const ListMenu: React.FC<Props> = ({
  conversationList,
  menuTitle,
  isLoading,
}) => {
  const { loggedIn } = React.useContext(UserContext);
  const [open, setOpen] = React.useState(true);
  const { isDeveloper } = userService();

  const handleClick = () => {
    setOpen(!open);
  };

  return loggedIn ? (
    <>
      <List dense>
        <ListItemButton onClick={handleClick}>
          <ListItemIcon sx={{ minWidth: 40 }}>
            <ChatIcon />
          </ListItemIcon>
          <ListItemText primary={menuTitle} />
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </ListItemButton>
        <Collapse in={open} timeout="auto" unmountOnExit>
          {isLoading && <ListSkeleton contrast />}
          <List
            sx={{
              '.active': {
                bgcolor: '#dfdfdf',
              },
            }}
            component="div"
            disablePadding
          >
            {conversationList?.map(
              ({ name, uid, retrieval_bundle_slugs = [''], aiflow_slug }) => (
                <ListItem
                  component={NavLink}
                  to={`/conversation/${uid}`}
                  key={uid}
                  disablePadding
                  dense
                >
                  <ListItemButton sx={{ pl: 3 }}>
                    <ListItemIcon sx={{ minWidth: 40 }}>
                      <ArtTrackIcon />
                    </ListItemIcon>
                    {/* <Tooltip
                      title={
                        <>
                          <BundleTextList slugs={retrieval_bundle_slugs} />

                          {isDeveloper && (
                            <>
                              <br />
                              <AiFlowTextList slug={aiflow_slug} />
                            </>
                          )}
                        </>
                      }
                    > */}
                    <ListItemText
                      sx={{
                        minWidth: 0,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                      primary={name}
                    />
                    {/* </Tooltip> */}
                  </ListItemButton>
                </ListItem>
              ),
            )}
          </List>
        </Collapse>
      </List>
    </>
  ) : null;
};

export const ConversationMenu: React.FC = () => {
  const { loggedIn } = React.useContext(UserContext);

  const { conversationList, sharedConversationList, conversationIsLoading } =
    conversationService();

  const hasSharedConversation = !!sharedConversationList?.length;

  return loggedIn ? (
    <>
      <ListMenu
        conversationList={conversationList}
        menuTitle="Conversations"
        isLoading={conversationIsLoading}
      />
      {hasSharedConversation && (
        <ListMenu
          conversationList={sharedConversationList}
          menuTitle="Shared conversations"
          isLoading={conversationIsLoading}
        />
      )}
    </>
  ) : null;
};
